/* global bsBreakpoints jQuery */

/* eslint-disable no-unused-vars */

const config = {
	root: document.getElementsByClassName('layout-container')[0],
};

/**
 * @description Initialisation de bs-breakpoints
 * @see https://github.com/Johann-S/bs-breakpoints/
 */
document.addEventListener('DOMContentLoaded', () => {
	bsBreakpoints.init();
});

(function () {
	// MacOs Hack
	if (navigator.platform === 'MacIntel') {
    document.querySelector('html').classList.add('macos');
	}

	// iOs Mobile Hack
	if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
    document.querySelector('html').classList.add('ios');
	}
})();
